import React, { useState } from 'react';
import './AlertsPanel.css';
import { resolveAlert } from '../services/api';
import { formatDateTime } from '../utils/dateFormat';
import { useAuth } from '../context/AuthContext';

const AlertsPanel = ({ alerts, onAlertClick, onAlertResolved }) => {
  const [resolvingId, setResolvingId] = useState(null);
  const { authData } = useAuth();

  const handleResolveAlert = async (e, alertId) => {
    e.stopPropagation(); // Prevent opening the popup when clicking resolve
    if (window.confirm('Resolve this alert?')) {
      setResolvingId(alertId);
      try {
        const userName = authData?.userName || null;
        await resolveAlert(alertId, userName);
        // Call the resolve handler which will refresh the alerts
        if (onAlertResolved) {
          await onAlertResolved(alertId);
        }
      } catch (error) {
        console.error('Failed to resolve alert:', error);
        alert('Failed to resolve alert. Please try again.');
      } finally {
        setResolvingId(null);
      }
    }
  };
  const getAlertIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return <span className="alert-icon alert-critical">!</span>;
      case 'warning':
        return <span className="alert-icon alert-warning">⚠</span>;
      default:
        return <span className="alert-icon alert-info">ℹ</span>;
    }
  };


  if (!alerts || alerts.length === 0) {
    return (
      <div className="alerts-empty">
        <p>No alerts</p>
      </div>
    );
  }

  return (
    <div className="alerts-panel">
      {alerts.map((alert, index) => (
        <div 
          key={`${alert.id}-${index}-${alert.timestamp || ''}`} 
          className={`alert-item alert-${alert.severity}`}
          onClick={() => onAlertClick && onAlertClick(alert)}
          style={{ cursor: onAlertClick ? 'pointer' : 'default' }}
        >
          {getAlertIcon(alert.severity)}
          <div className="alert-header">
            <div className="alert-header-info">
              {alert.siteName && (
                <span className="alert-site-name">{alert.siteName}</span>
              )}
              <span className="alert-time">{formatDateTime(alert.timestamp)}</span>
            </div>
          </div>
          <div className="alert-content">
            <div className="alert-message">{alert.message}</div>
            {alert.siteIp && (
              <div className="alert-site-ip">IP: {alert.siteIp}</div>
            )}
          </div>
          <div className="alert-actions">
            <button
              className="resolve-btn"
              onClick={(e) => handleResolveAlert(e, alert.id)}
              disabled={resolvingId === alert.id}
              title="Resolve alert"
            >
              {resolvingId === alert.id ? 'Resolving...' : 'Resolve'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertsPanel;

